module.exports = __webpack_public_path__ + "static/promo-text-3275bb4bddcb53e738f45da22c32a454.svg";